<template>
  <div>
    <a-modal
      v-show="!ishand"
      id="warp_sim12"
      width="40rem"
      v-model="visible"
      on-ok="handleOk1"
      v-dragModal
      @cancel="handleCancel(0)"
      :footer="null"
      :keyboard="false"
      :maskClosable="false"
      :dialog-style="{top: 15 +'%'}"
    >
      <div class="mark-file">
        <div
          style="
            background-color: #0c8b97;
            border-radius: 10px 10px 0 0;
            color: #fff;
            width: 38rem;
            margin: 1rem 1rem 0 1rem;
            text-align: center;
          "
        >
          <span style="font-size: 1rem;">添加開戶</span>
        </div>
      </div>
      <div solt="title" style="position: relative">
        <!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
      </div>
      <div class="content">
        <div style="padding-top: 1.5rem; position: relative;font-size: 0.8rem; ">
          <div class='table_flex table_margin'>
            <div class='table_flex'>
              <div class="name_flex">中文名稱：</div>
              <!-- v-model="formItem." -->
              <a-input v-model="formItem.cn_name"  @input='formItem.cn_name = formItem.cn_name.replace(/[^\u4e00-\u9fa5]/g,"")' placeholder="請輸入中文名稱"/>
            </div>
            <div style="width:5%;flex-shrink: 0;"></div>
            <div class='table_flex'>
              <div class="name_flex">英文名稱：</div>
              <a-input v-model="formItem.en_name"  :class="{'border_red': obj.flag1}"  @input="obj.flag1=false,formItem.en_name=formItem.en_name.replace(/[^a-z A-Z]/g,'')"  placeholder="請輸入英文名稱"/>
            </div>
          </div>
          <div class='table_flex table_margin'>
            <div class='table_flex'>
              <div class="name_flex">稱謂：</div>
              <!-- v-model="formItem." -->
              <a-select ref="select" v-model="formItem.cal"   :class="{'border_red': obj.flag9}" @change="obj.flag9=false" :placeholder="'請選擇稱謂'" style="width: 100%">
                <a-select-option value="0">先生</a-select-option>
                <a-select-option value="1">小姐</a-select-option>
                <a-select-option value="3">太太</a-select-option>
              </a-select>
            </div>
            <div style="width:5%;flex-shrink: 0;"></div>
            <div class='table_flex addkh_class'>
              <div class="name_flex">出生日期：</div>
              <a-date-picker v-model="formItem.birth" :disabled-date="disabledDate"  @change="obj.flag8=false,modifyTime()" :class="{'border_red': obj.flag8}"  style="width: 100%;" class='warp_width' placeholder='請選擇出生日期' />
              <!-- <el-date-picker
              :class="{'border_red': obj.flag8}"
              style="width: 100%;"
                v-model="formItem.birth"
                type="date"
                :clearable="false"
                  :default-value="
                    new Date().setFullYear(new Date().getFullYear())
                  "
                  :picker-options="pickerOptions"
                  placeholder="請選擇出生日期"
                  @change="obj.flag8=false"
                /> -->
              <!-- <a-input v-model="formItem.en_name"  :class="{'border_red': obj.flag1}"  @input="obj.flag1=false,formItem.en_name=formItem.en_name.replace(/[^a-z A-Z]/g,'')"  placeholder="請輸入英文名稱"/> -->
            </div>
          </div>
          <div class='table_flex table_margin'>
            <div class='table_flex'>
              <div class="name_flex">國籍(中文)：</div>
              <!-- v-model="formItem." -->
              <a-input v-model="formItem.nationality" @input='formItem.nationality = formItem.nationality.replace(/[^\u4e00-\u9fa5]/g,"")' placeholder="請輸入國籍(中文)"/>
            </div>
            <div style="width:5%;flex-shrink: 0;"></div>
            <div class='table_flex'>
              <div class="name_flex">國籍(英文)：</div>
              <a-input v-model="formItem.nationality_en"  :class="{'border_red': obj.flag2}" @input="obj.flag2=false,formItem.nationality_en=formItem.nationality_en.replace(/[^a-z A-Z]/g,'')" placeholder="請輸入國籍(英文)"/>
            </div>
          </div>
          <div class='table_flex table_margin'>
            <div class='table_flex'>
              <div class="name_flex">電話號碼：</div>
              <a-select v-model="formItem.nationcode" class="qhXz" style='width: 25%;flex-shrink: 0; margin-right: 2%;' >
                  <a-select-option v-for="(item) in qhArr" :key="item.id" :label="'+ '+item.value"  :value="item.value">
                      <span style="font-size:.8rem;">+{{ item.value }}</span>
                  </a-select-option>
              </a-select>
              <!-- v-model="formItem." -->
              <a-input v-model="formItem.phonenum" v-if="formItem.nationcode =='852'"  :maxLength="8" :class="{'border_red': obj.flag3}" @input="obj.flag3=false,formItem.phonenum=formItem.phonenum.replace(/[^\d]/g,'')" placeholder="請輸入電話號碼"/>
              <a-input v-model="formItem.phonenum" v-else :maxLength="11" :class="{'border_red': obj.flag3}" @input="obj.flag3=false,formItem.phonenum=formItem.phonenum.replace(/[^\d]/g,'')" placeholder="請輸入電話號碼"/>
            </div>
            <div style="width:5%;flex-shrink: 0;"></div>
            <div class='table_flex'>
              <div class="name_flex">電郵地址：</div>
              <a-input v-model="formItem.email"  :class="{'border_red': obj.flag4}"  @input="obj.flag4=false,formItem.email=formItem.email.replace(/[\u4E00-\u9FA5]/g,'')" placeholder="請輸入電郵地址" @blur='emailfn(formItem.email)'/>
            </div>
          </div>
          <div class='table_flex table_margin'>
            <div class='table_flex'>
              <div class="name_flex">身份信息：</div>
              <!-- v-model="formItem." -->
              <a-input v-model="formItem.id_number"  :class="{'border_red': obj.flag5}"  @input="obj.flag5=false,formItem.id_number=formItem.id_number.replace(/[\u4E00-\u9FA5]/g,'')" placeholder="請輸入身份信息"/>
            </div>
            <div style="width:5%;flex-shrink: 0;"></div>
            <div class='table_flex'>
              <div class="name_flex">場外交易：</div>
              <a-select v-model="formItem.otcTrading" style="width: 100%;">
                <a-select-option :value="0">未簽署</a-select-option>
								<a-select-option :value="1">已簽署</a-select-option>
              </a-select>
              <!-- <a-input  placeholder="請輸入場外交易"/> -->
            </div>
          </div>
          <div class='table_flex table_margin'>
            <div class='table_flex'>
              <div class="name_flex">銀行名稱：</div>
              <!-- v-model="formItem." -->
              <a-input  v-model="formItem.bank" placeholder="請輸入銀行名稱"/>
            </div>
            <div style="width:5%;flex-shrink: 0;"></div>
            <div class='table_flex'>
              <div class="name_flex">銀行號碼：</div>
              <a-input  v-model="formItem.bank_number" @input="formItem.bank_number=formItem.bank_number.replace(/\D/g,'')" placeholder="請輸入銀行號碼"/>
            </div>
          </div>
          <div class='table_flex table_margin'>
            <div class='table_flex'>
              <div class="name_flex">居住國家：</div>
              <!-- v-model="formItem." -->
              <a-input  v-model="formItem.residential_nationality"  @input="obj.flag6=false,formItem.residential_nationality=formItem.residential_nationality.replace(/[^a-z A-Z]/g,'')"  :class="{'border_red': obj.flag6}" placeholder="請輸入居住國家"/>
            </div>
            <div style="width:5%;flex-shrink: 0;"></div>
            <div class='table_flex'></div>
          </div>
          <div class='table_flex table_margin'>
            <div class='table_flex' style="align-items: flex-start;">
              <div class="name_flex">通訊中文：</div>
              <a-textarea v-model="formItem.address" @input='formItem.address = formItem.address.replace(/[^\u4e00-\u9fa5]/g,"")' style='color: #000000;'  placeholder="請輸入通訊中文" :auto-size="{ minRows: 2, maxRows: 2 }" :maxLength='130'></a-textarea>
            </div>
          </div>
          <div class='table_flex table_margin'>
            <div class='table_flex' style="align-items: flex-start;">
              <div class="name_flex">通訊英文：</div>
              <!-- v-model="formItem." -->
              <a-textarea v-model="formItem.address_en" :class="{'border_red': obj.flag7}" @input="obj.flag7=false,formItem.address_en=formItem.address_en.replace(/[\u4E00-\u9FA5]/g,'')" style='color: #000000;' placeholder="請輸入通訊英文" :auto-size="{ minRows: 2, maxRows: 2 }" :maxLength='130'></a-textarea>
            </div>
          </div>
          <div style="text-align: center;margin:0.5rem 0">
            <button
              class="btn1 btnx"
              @click="handleCancel(1)"
              v-html="'提&emsp;交'"
            ></button>
          </div>
        </div>
      </div>
      <div style="width: 100%; height: 1px"></div>
    </a-modal>
  </div>
</template>

<script>
import App from "@/assets/app.js";
import dayjs from 'dayjs';
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import moment from "moment";
export default {
  props: [],
  data() {
    return {
      ishand: false,
      visible: true,
      locale:zhCN,
      userfileAuditAdmin: this.$store.state.rolesdata.indexOf("userfileAuditAdmin") >= 0,

      formItem:{
        cn_name:'',
        en_name:'',
        cal:undefined,
        birth: "",
        nationality:'',
        nationality_en:'',
        nationcode:'852',
        phonenum:'',
        email:'',
        id_number:'',
        otcTrading:0,
        bank:'',
        bank_number:'',
        residential_nationality:'',
        address:'',
        address_en:'',
      },
      qhArr: [
        {
          id: "1",
          value: "86",
          label: '中國',
        },
        {
          id: "2",
          value: "852",
          label: '中國香港',
        },
        {
          id: "3",
          value: "853",
          label: '中國澳門',
        },
        {
          id: "4",
          value: "61",
          label: '澳大利亞',
        },
        {
          id: "5",
          value: "1",
          label: '加拿大',
        },
        {
          id: "6",
          value: "60",
          label: '馬來西亞',
        },
        {
          id: "7",
          value: "1",
          label: '美國',
        },
        {
          id: "8",
          value: "65",
          label: '新加坡',
        },
        {
          id: "9",
          value: "64",
          label: '新西蘭',
        },
        {
          id: "10",
          value: "44",
          label: '英國',
        },
      ],
      obj:{
        flag1:false,
        flag2:false,
        flag3:false,
        flag4:false,
        flag5:false,
        flag6:false,
        flag7:false,
        flag8:false,
        flag9:false,
      },
    };
  },
  mounted() {
  },
  methods: {
    modifyTime(){
      this.formItem.birth = App.oDate.secsTime3(this.formItem.birth._d)
    },
    disabledDate(current) {
      var now = '1918-01-01';
      var nows = '2005-01-01'
      var moment = this.$moment(now,'YYYY-MM-DD');
      var moments = this.$moment(nows,'YYYY-MM-DD');
      // return current < moment || current > moments; 限制18岁之前不可选
      return current < moment || current > this.$moment().endOf("day");
    },
    emailfn(ind) {
      if (this.formItem.email) {
        var t = /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/;
        if (!(t.test(this.formItem.email))) {
          this.formItem.email = ''
          this.$message.warning('請輸入正確的電郵地址')
        }
      }
    },
    handleCancel(ev) {
      if(ev == 1){
        if (!this.formItem.en_name) {
          this.obj.flag1 = true
        }
        if (!this.formItem.nationality_en) {
          this.obj.flag2 = true
        }
        if (!this.formItem.phonenum) {
          this.obj.flag3 = true
        }
        if (!this.formItem.email) {
          this.obj.flag4 = true
        }
        if (!this.formItem.id_number) {
          this.obj.flag5 = true
        }
        if (!this.formItem.residential_nationality) {
          this.obj.flag6 = true
        }
        if (!this.formItem.address_en) {
          this.obj.flag7 = true
        }
        if (!this.formItem.birth) {
          this.obj.flag8 = true
        }
        if (!this.formItem.cal) {
          this.obj.flag9 = true
        }
        if (this.obj.flag1 || this.obj.flag2 || this.obj.flag3 || this.obj.flag4 || this.obj.flag5 || this.obj.flag6 || this.obj.flag7|| this.obj.flag8|| this.obj.flag9) {
          return
        }

        this.$ajax({
          method: "post",
          url: this.$api.addAccountOpeningInformation,
          data:this.formItem,
        }).then((res) => {
          if (res.data.qmiscode == 1000) {
            App.oTool.successT();
            this.$emit("child", this.formItem);
          } else {
            App.oTool.warningT(res.data.qmismsg);
            // this.$emit("child", this.formItem);
          }
        });
      }else{
        this.$emit("child", this.formItem);
      }
    },
   
  },
};
</script>
<style>
    .border_red{
      border-color: red !important;
    }
    .border_red .ant-select-selection{
      border-color: red !important;
    }
    .border_red .ant-calendar-picker-input{
      border-color: red !important;
    }
    .border_red .ant-input{
      border-color: red !important;
    }
    .border_red .el-input__inner{
      border-color: red !important;
    }
    .addkh_class  .is-active{
      border-color:#FF6A00!important;
    }
    .addkh_class .is-active:hover{
        border-color:#FF6A00!important;
    }
</style>
<style scoped>
  .table_flex{
    display: flex;
    width: 100%;
    align-items: center;
  }
  .name_flex{
    width: 4.8rem;
    flex-shrink: 0;
    text-align: right;
  }
  .table_margin{
    margin-bottom: 1rem;
  }
</style>
<style lang="scss">
.addkh_class .el-input__icon{
  line-height: 35px !important;
}

  .el-icon-arrow-up:before{
    font-family: 'element-icons' !important;
  }
  .el-range-editor.is-active, .el-range-editor.is-active:hover, .el-select .el-input.is-focus .el-input__inner{
    border-color:#279da3 !important;
  }
  .el-input__inner{
    height:35.5px

  }
  .el-select .el-input__inner:focus{
    border-color:#279da3 !important;
  }
  .el-select-dropdown__item.selected{
    color: rgba(0,0,0,.65) !important;
    font-weight: 400 !important;
    font-size: 16px !important;
  }
.phoneSty .ant-select-arrow {
  right: 6px !important;
}
.phoneSty .ant-input-affix-wrapper .ant-input:not(:first-child) {
  padding-left: 28% !important;
}
.phoneSty .ant-input-affix-wrapper .ant-input-prefix {
  left: 2px !important;
  top: 18px;

}
.phoneSty .ant-input-affix-wrapper .ant-input-prefix :not(.anticon),
.ant-input-affix-wrapper .ant-input-suffix :not(.anticon) {
  line-height: 25.5px !important;
}
.phoneSty .ant-select-selection {
  border: 0 !important;
  height: 25px;
}
.phoneSty .ant-select-focused .ant-select-selection,
.ant-select-selection:active,
.ant-select-selection:focus {
  border: 0 !important;
  box-shadow: none !important;
}


.address .ant-form-item-label {
  width: 15% !important;
}
.address .ant-form-item-control-wrapper {
  width: 85% !important;
}
.content {
  padding-bottom: 1rem;
  border-radius: 0 0 10px 10px;
  padding: 1rem;
  background-color: #fff;
  width: 38rem;
  margin: 0 auto;
  margin-bottom: 1rem;
  min-height: 50px;
}
#warp_sim12 .ant-modal-header,
#warp_sim12 .ant-modal-body {
  background-color: #e5e5e5 !important;
  padding: 1rem;
  padding-top: 0.7rem;
}

.mark-file {
  position: absolute;
  top: 0;
  left: 0;

  div {
    width: 6rem;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    display: inline-block;
  }
}

#warp_sim12 {
  .ant-radio-wrapper {
    display: flex;
    align-items: center;
  }
  .ant-form-explain {
    display: none;
  }

  .ant-modal {
    top: 28%;
  }

  .ant-col-12 {
    text-align: right;
  }
  .myleft {
    text-align: left;
  }
  .ant-form-item-label {
    width: 30%;
  }

  .ant-form-item,
  .ant-form-item-control {
    width: 100%;

    .ant-calendar-picker {
      width: 100%;
    }
  }

  .ant-radio-group-default {
    width: 100%;
    margin-top: 0.3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-size: 0.8rem;
    }
  }

  .ant-form-item-control-wrapper {
    width: 70%;

    .ant-form-item-control {
      width: 100%;
    }
  }

  #lastname {
    text-align: right;

    .ant-form-item-label {
      width: 10%;
    }

    .ant-form-item-control-wrapper {
      width: 86%;
    }
  }

  .ant-form-inline .ant-form-item {
    margin-right: 0;
  }

  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-form-item {
    margin-bottom: 1rem;
  }

  .ant-form-item label {
    font-size: 0.8rem !important;
  }

  .ant-input {
    font-size: 0.8rem !important;
  }

  .ant-select-selection-selected-value {
    font-size: 0.8rem !important;
  }

  .ant-form-item-children {
    font-size: 0.8rem !important;
  }

  .ant-modal-body {
    padding: 0;
    padding-top: 2.5rem;
  }

  .btn1 {
    cursor: pointer;
    width: 8rem;
    height: 2rem;
    font-size: 0.8rem;
    color: #fff;
    border: 0;
    border-radius: 5px;
    margin: 0 3rem;
  }

  .btnx {
    background-color: #0c8b97;
  }

  .btn2 {
    background-color: #ed4849;
  }

  .mydivs {
    max-height: 7rem;
    overflow-y: auto;
    // margin-bottom: 1rem;
    padding: 1rem;
    margin-left: 4%;
    width: 96%;
    background-color: #f5f5f5;
    margin-bottom: 1rem;

    .c {
      font-size: 0.8rem;
    }

    .f {
      // text-align: right;
      display: flex;
      justify-content: space-between;
    }

    .t {
      margin: 0.5rem 0;
      border-bottom: 1px solid #d9d9d9;
    }
  }
}
</style>
